import { KeyRound } from "lucide-react";
import { CARD } from "./esriQualApi";

// Clé lue uniquement depuis la variable d'environnement standard ESRI_ACCESS_TOKEN (jamais saisie ni affichée ici).
export function SecretCard({ secret }) {
  return (
    <section data-testid="esri-secret-card" className={CARD}>
      <h2 className="font-chivo text-base md:text-lg font-black uppercase tracking-tight flex items-center gap-2"><KeyRound size={16} /> 1 · Clé ESRI_ACCESS_TOKEN</h2>
      <div className="font-mono text-[10px] text-[#A3A3A3]">
        CONFIGURÉE : <b data-testid="esri-secret-present" className={secret.present ? "text-[#22C55E]" : "text-[#EF4444]"}>{secret.present ? "OUI" : "NON"}</b> · SOURCE : <span data-testid="esri-secret-source">{secret.source}</span> · valeur jamais affichée
      </div>
      {!secret.present && (
        <ol data-testid="esri-secret-howto" className="font-mono text-[10px] text-[#F59E0B] list-decimal pl-4 space-y-0.5">
          <li>Déploiement : Deployments → votre application → Secrets → ajouter <b>ESRI_ACCESS_TOKEN</b> (valeur saisie par vous, jamais dans le chat).</li>
          <li>Redéployer pour que le Backend charge la variable, puis revenir ici.</li>
          <li>Sans cette variable, seule la cartographie Esri est indisponible ; le reste de SKYCORE fonctionne normalement.</li>
        </ol>
      )}
    </section>
  );
}
